import React from "react";
import AttestationBloreMain from "../../AttestationPage/AttestationBlore/AttestationBloreMain";
import AttestationBloreHead from "../../AttestationPage/AttestationBlore/AttestationBloreHead";
import "./../../AttestationPage/AttestationBlore/AttestationBlore.css";
import blore from "./../../../vid_img/blore.jpg";

const ApostilleBlore = () => {
  return (
    <div className="attestationBloreContiner">
      <AttestationBloreHead span="Apostille" head=" Services in Bengaluru" />
      <AttestationBloreMain
        mainImg={blore}
        mainHead="Certificate Apostille In India"
        mainPara1="In today’s global world, international travel for education, employment, migration, or business is increasingly common. But before crossing borders, there’s an essential legal procedure that ensures your documents are valid and recognized abroad—apostille. Apostille is a form of international document authentication that eliminates the need for further embassy-level legalizations when traveling between countries that are members of the Hague Convention."
        mainPara2="An apostille is a certificate issued under the Hague Apostille Convention of 1961, an international treaty that simplifies the process of legalizing public documents so they can be accepted in any of the 100+ member countries. It serves as an official confirmation that a document is genuine and can be legally used in another country. This includes personal documents like birth or marriage certificates, educational documents such as degrees or diplomas, and commercial papers for business purposes."
      />
    </div>
  );
};

export default ApostilleBlore;
